<template>
<div>
    <div v-if="books.isSerial == 1">
        <div class="bookitem">
            <router-link :to="{path:'/bookdetail',query:{bookId:books.bookId}}">
                <img class="faceimg" :src="books.faceImgPlay | objs" />
                <p class="f18">
                    <nobr>{{books.bookName}}</nobr>
                </p>
                <p class="f14">[{{books.nationName}}]{{books.author}} <span class="effectTime">{{books.effectTime.substr(0,10)}}</span></p>
                <p class="f16">{{books.slogan}}</p>
                <p>
					<!-- <span class="ludubi">{{books.priceTag || '0.00'}}</span> -->
					<span class="f12">{{books.listenCount}}已听</span></p>
            </router-link>
        </div>
    </div>
    <div v-else>
        <div class="bookitem">
            <router-link :to="{path:'/booklist',query:{listId:books.serialId}}">
                <img class="faceimg" :src="books.faceImgPlay | objs" />
                <p class="f18">
                    <nobr>{{books.bookName}}</nobr>
                </p>
                <p class="f14">[{{books.nationName}}]{{books.author}}  <span class="effectTime">{{books.effectTime.substr(0,10)}}</span></p>
                <p class="graybg"><span v-if="books.isLast==2">完结</span>（已更新至{{books.total}}期）</p>
                <p class="f16" v-html="books.slogan"></p>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'BookItem',
    props: [
        "books"
    ]
}
</script>

<style scoped>
a {
    text-decoration: none;
}
.effectTime{float: right; color: rgba(75, 204, 170, 1);}
.bookitem {
    width:70%;
    margin:0 auto;
    padding: 30px 15% 50px 15%;
    height: 200px; 
    background-image: url(../assets/todaybottom.png);
    background-position: bottom center;
    background-size: 1100px 114px;
    background-repeat: no-repeat;
}

.bookitem .faceimg {
    width: 180px;
    height: 180px;
    float: left;
    border: 1px;
    margin-right: 10px;
    background: rgba(210, 210, 210, 1);
    box-shadow: 1px 1px 10px 0px rgba(173, 195, 189, 0.43);
    border-radius: 2px;
    margin-right: 15px;
}
.bookitem .faceimg:hover{
    box-shadow: 1px 1px 10px 0px rgba(75, 204, 170, 0.5) !important;
}
.bookitem p {
    padding: 0;
    margin: 10px;
}

.f18 {
    height: 22px;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(36, 41, 38, 1);
}
.f16{ 
font-size: 16px;
font-family: Source Han Serif CN;
font-weight: 400;
color: #9CA6A6;
line-height: 32px;
height: 88px;
overflow: hidden;
}
.f14 {
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
    width: 90%;
}

.f12 {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
    float: right;
}

.graybg {
    background: rgba(246, 247, 247, 1);
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    width: 90%;
}

.graybg span {
    display: inline-block;
    padding: 2px 4px;
    background: rgba(75, 204, 170, 1);
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 10px;
}

.ludubi {
    padding-right: 65px;
    margin-right: 15px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    height: 22px;
    background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 65px 18px;
    display: inline-block;
}
</style>
